import React from 'react';
import Img from "../../images/services/mvp/Mvp.png";
import {Container, Row, Col} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Buildpurpose(props) {
    return (
        <div className="services_orange_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto text-center order-2 order-md-1">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="services_title my-auto order-1 order-md-2">
                        <h2>Build Your Own Minimum Viable Product</h2>
                        <p>TekRevol allows you to build your minimum viable product with all the aspects comprehensively covered. Our understanding and experience of the product development process allow us to use that knowledge to build efficient products that achieve big in less time.</p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Buildpurpose;